export default __webpack_public_path__ + "static/Quickinstallation_Tile_8815_Step_12-ff2d79511931be303b1d6eb184b4cc91.webp";